<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <h1 class="page-title">Users Management</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Users Management</span>
        </div>
    </div>

    <hr class="mb-3" />

    <div class="row ">
        <div class="col-12 col-sm-12 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-icon style="font-size: 20px;" matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
                    <div class="filters" matSuffix *ngIf="filterTotal > 0; else elseFilterTotalZero">
                        <mat-icon style="margin: 5px;" class="filters" matSuffix (click)="openAdvanceSearch()">tune</mat-icon>
                        <span class="filter-number" matSuffix>{{filterTotal}}</span>
                        <mat-icon style="margin: 5px;" class="filters" matSuffix (click)="clearFilters()">close</mat-icon>
                    </div>
                    <ng-template #elseFilterTotalZero>
                        <mat-icon matSuffix (click)="openAdvanceSearch()">tune</mat-icon>
                    </ng-template>

                </mat-form-field>

            </div>
            </div>

    </div>

    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <div  style="overflow-x: auto;">
            <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap"></th>
                <th class="text-nowrap">Full Name</th>
                <th class="text-nowrap">Email</th>
                <th class="text-nowrap">Date Joined</th>
                <th class="text-nowrap">Status</th>
                <th class="text-nowrap">Account Type</th>
                <th class="text-nowrap">User Role</th>
                <th class="text-nowrap">Referred By</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of users">
                <td class="text-nowrap">
                    <mat-icon class="accent-orange" [matTooltip]="'Administrator'" *ngIf="checkAdmin(user)">star</mat-icon>
                    <mat-icon class="accent-green" [matTooltip]="'Member'" *ngIf="!checkAdmin(user)">face</mat-icon>
                </td>
                <td class="text-nowrap">{{ user.fullName }}</td>
                <td class="text-nowrap" >{{ user.email }}
                </td>
                <td class="text-nowrap">{{ user.createDate| date : "MM/dd/y hh:mm:ss" }}</td>
                <td class="text-center">
                    <mat-icon class="accent-orange" *ngIf="user.enabled">verified_user</mat-icon>
                    <mat-icon color="warn" *ngIf="!user.enabled">no_accounts</mat-icon>
                </td>
                <td  class="ellipsis">{{ user.accountType }}</td>
                <td class="text-nowrap">{{user.role}}</td>
                <td class="text-nowrap">{{user.referredBy}}</td>
                <td class="sticky-action" style="width: 80px">
                    <button [matTooltip]="'Edit user'" class="accent-orange" (click)="editUser(user)" mat-icon-button aria-label="edit user">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button [matTooltip]="'Delete user'" class="crimson-red" *ngIf="user.enabled" (click)="deleteUser(user)" mat-icon-button aria-label="delete user">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button [matTooltip]="'Restore user'" *ngIf="!user.enabled" (click)="restoreUser(user)" mat-icon-button aria-label="restore user">
                        <mat-icon>history</mat-icon>
                    </button>
                    <button class="accent-orange" [matTooltip]="'Set as administrator'" *ngIf="user.enabled && !checkAdmin(user)" (click)="makeAdmin(user)" mat-icon-button aria-label="make admin user">
                        <mat-icon>star</mat-icon>
                    </button>
                    <button class="accent-green" [matTooltip]="'Revoke as administrator'" *ngIf="user.enabled && checkAdmin(user)" (click)="revokeAdmin(user)" mat-icon-button aria-label="make admin user">
                        <mat-icon>face</mat-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="users.length == 0">
                <td colspan="8" class="text-center">
                    <span>No Record</span>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
    <div class="mt-4" *ngIf="users.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>

    </div>
</div>


